import React from "react";
import { NavLink } from "react-router-dom";
import { Spinner } from "reactstrap";

import "./navBar.scss";
import AuthContext from "../../context/auth-context";

const NavBar = ({ loading }) => {
  return (
    <AuthContext.Consumer>
      {(context) => {
        return (
          <header className="main-navigation">
            <h2>
              <NavLink to="/tasks">Task Manager</NavLink>
            </h2>
            {loading ? (
              <Spinner className="bigSpinner" color="primary" />
            ) : (
              context.user && (
                <h4>
                  <span style={{ color: "white" }}>{">>"}</span>{" "}
                  {context.user.name}
                </h4>
              )
            )}
          </header>
        );
      }}
    </AuthContext.Consumer>
  );
};

export default NavBar;
